/**
 * WorkflowActivity entity validation rules.
 */

import { getEntityAttr, getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

function normBool(v: any): boolean {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') return v.toLowerCase() === 'true';
    return false;
}

export function getWorkflowActivityWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];

    const displayName = getEntityAttrString(data, 'DisplayName');
    if (!displayName) {
        warnings.push({
            message: 'Display Name should not be empty.',
            severity: 'warning',
            attributeDisplayNames: ['Display Name']
        });
    }

    const action = normBool(getEntityAttr(data, 'Action'));
    const authorization = normBool(getEntityAttr(data, 'Authorization'));
    const request = normBool(getEntityAttr(data, 'Request'));
    if (!action && !authorization && !request) {
        warnings.push({
            message: 'At least one of Action, Authorization, or Request must be true.',
            severity: 'warning',
            attributeDisplayNames: ['Action', 'Authorization', 'Request']
        });
    }

    return warnings;
}
